import { useEffect, useState } from 'react'

export const useDocumentLoaded = () => {
  const [loaded, setLoaded] = useState(document.readyState === 'complete')
  useEffect(() => {
    const listener = () => {
      setLoaded(document.readyState === 'complete')
    }

    if (loaded) {
      return
    }

    document.addEventListener('readystatechange', listener)

    return () => {
      document.removeEventListener('readystatechange', listener)
    }
  }, [loaded])

  return loaded
}
